import React, { useState } from 'react';
import { FaRegEdit, FaRegTrashAlt } from 'react-icons/all';
import JurisdictionModal from '../account_modals/JurisdictionModal';
import JurisdictionDeleteModal from '../account_modals/JurisdictionDeleteModal';

export default function MyCle({ data, jurisdictions }) {
  const [currentSettings, setCurrentSettings] = useState(null);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const renderJurisdictions = () => (
    <ul className="jurisdiction-list">
      {data.user_cle_settings.map((s) => (
        <li key={s.id} className="jurisdiction-item">
          <h4 className="jurisdiction-name">
            {s.cle_jurisdiction.name}
          </h4>
          <div className="jurisdiction-body">
            {s.license_number && (
              <p className="jurisdiction-field">
                License Number:
                {' '}
                {s.license_number}
              </p>
            )}
            {s.year_admitted && (
              <p className="jurisdiction-field">
                Year Admitted:
                {' '}
                {s.year_admitted}
              </p>
            )}
            {(s.cle_data && s.cle_data.compliance_group) && (
              <p className="jurisdiction-field">
                Compliance Group:
                {' '}
                {s.cle_data.compliance_group}
              </p>
            )}
            {(s.cle_jurisdiction.deadline && s.cle_data && s.cle_data.deadline) && (
              <p className="jurisdiction-field">
                Deadline:
                {' '}
                {new Date(s.cle_data.deadline).toISOString().slice(0, 10)}
              </p>
            )}
          </div>
          <div className="jurisdiction-actions">
            <FaRegEdit
              title="Edit"
              onClick={() => {
                setCurrentSettings(s);
                setUpdateModalOpen(true);
              }}
            />
            <FaRegTrashAlt
              title="Delete"
              onClick={() => {
                setCurrentSettings(s);
                setDeleteModalOpen(true);
              }}
            />
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <div
        className="update"
        style={{ marginTop: '-1rem', marginBottom: '1rem' }}
        onClick={() => {
          setCurrentSettings(null);
          setUpdateModalOpen(true);
        }}
      >
        Add Jurisdiction
      </div>
      {data?.user_cle_settings && data.user_cle_settings.length > 0
        ? renderJurisdictions()
        : <p>No CLE Jurisdictions added yet.</p>}
      {updateModalOpen && (
        <JurisdictionModal
          onClose={() => setUpdateModalOpen(false)}
          jurisdictions={jurisdictions.filter((j) => !data.user_cle_settings.some((setting) => setting.cle_jurisdiction.id === j.id))}
          item={currentSettings}
        />
      )}

      {deleteModalOpen && (
        <JurisdictionDeleteModal
          onClose={() => setDeleteModalOpen(false)}
          item={currentSettings}
        />
      )}
    </>
  );
}
